import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const normalise = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p);

// react-snap calls this just before saving each page.
// HTML serialisation merges adjacent text nodes ("Our Services in " + "Romford"), which React
// hydration rejects (#418). Insert the same <!-- --> separators React's own server renderer uses.
window.snapSaveState = () => {
  const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT);
  const pairs = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.nextSibling && node.nextSibling.nodeType === Node.TEXT_NODE) pairs.push(node);
  }
  pairs.forEach((n) => n.parentNode.insertBefore(document.createComment(" "), n.nextSibling));
  return { __SNAP_PATH__: normalise(window.location.pathname) };
};

// Hydrate only when the served snapshot was made for this exact route. A host fallback page
// (e.g. index.html served for /blog/some-post) is replaced by a fresh client render instead.
const snapshotMatchesRoute =
  rootElement.hasChildNodes() && window.__SNAP_PATH__ === normalise(window.location.pathname);

if (snapshotMatchesRoute) {
  hydrateRoot(rootElement, app, {
    onRecoverableError: (error, info) =>
      console.error("Hydration mismatch:", error, info && info.componentStack),
  });
} else {
  createRoot(rootElement).render(app);
}
